<template>
  <v-container fluid>
    <AboutBanner></AboutBanner>
    <AboutMain></AboutMain>
  </v-container>
</template>
<script>
import AboutBanner from "../components/ui/AboutBanner.vue";
import AboutMain from "../components/layout/AboutMain.vue"
export default {
  name: "About",
  components: {
      AboutBanner,
      AboutMain
  }
};
</script>
<style scoped></style>
